import { css, FlattenSimpleInterpolation } from 'styled-components';

export interface TypographyProps {
  font100: FlattenSimpleInterpolation;
  fontBold: FlattenSimpleInterpolation;
}

const typography: TypographyProps = {
  font100: css`
    font-size: 0.85rem;
    font-weight: normal;
    line-height: 1.42;
  `,
  fontBold: css`
    font-size: 1rem;
    font-weight: bold;
  `,
};

export default typography;
